module.exports = __webpack_public_path__ + "static/media/inner_38.77f9c35a.jpg";